(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsEditStaffBiographyController', CmsEditStaffBiographyController);

  /* ngInject */
  function CmsEditStaffBiographyController($state, $stateParams, $timeout, Flash, Upload, cmsStaffBiographyService, config, formErrorsService, sessionService) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.deletePhoto = deletePhoto;
    vm.deleteStaffBiography = deleteStaffBiography;
    vm.staffBiography = {};
    vm.staffBiographyForm = {};
    vm.saveStaffBiography = saveStaffBiography;
    vm.uploadPhoto = uploadPhoto;

    activate();

    function activate() {
      getStaffBiography();
    }

    function deletePhoto() {
      cmsStaffBiographyService(sessionService.getAuthToken()).deletePhoto({id: $stateParams.id});
    }

    function deleteStaffBiography() {
      cmsStaffBiographyService(sessionService.getAuthToken()).delete({id: $stateParams.id}, _deleteStaffBiographySuccess, _deleteStaffBiographyFailure);
    }

    function getStaffBiography() {
      cmsStaffBiographyService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => vm.staffBiography = response);
    }

    function saveStaffBiography() {
      vm.clearFormErrors();
      cmsStaffBiographyService(sessionService.getAuthToken()).update({id: $stateParams.id}, vm.staffBiography, _saveStaffBiographySuccess, _saveStaffBiographyFailure);
    }

    function uploadPhoto(photo) {
      photo.upload = Upload.upload({
        url: `${config.complianceServicesApiEndpoint}/api/cms/staff_biographies/${$stateParams.id}/photo`,
        method: 'POST',
        data: {photo: photo},
        headers: {
          'Authorization': `Token token=${sessionService.getAuthToken()}`
        }
      });

      photo.upload.then(response => {
        $timeout(() => {
          Flash.create('success', 'Photo successfully updated.');
          vm.staffBiography.photo_url = response.photo_url;
        });
      }, _response => {
        Flash.create('danger', 'An unexpected error occurred uploading photo.');
      });
    }

    function _deleteStaffBiographyFailure() {
      Flash.create('danger', 'An error occurred deleting the staff biography. Please try again later.');
    }

    function _deleteStaffBiographySuccess() {
      $state.go('application.compliance_services.cms_staff_biographies');
      Flash.create('success', 'The staff biography was successfully deleted.');
    }

    function _saveStaffBiographySuccess(response) {
      Flash.create('success', 'The staff biography was successfully created.');
      $state.go('application.compliance_services.cms_edit_staff_biography', {id: response.id});
    }

    function _saveStaffBiographyFailure(response) {
      Flash.create('danger', 'An error occurred with the submission, please correct the errors on the form and resubmit.');
      vm.setFormErrors(vm.staffBiographyForm, response);
    }
  }
})();
